import React, { useEffect, useState } from 'react'
import img from '../../assets/talent.svg'
import axios from 'axios'
import { toast, Toaster } from 'sonner'

const TalentCommunity = () => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const [formsubmitted, setFormSubmitted] = useState(false)

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [currentLocation, setCurrentLocation] = useState("");
  const [primaryInterest, setPrimaryInterest] = useState("");
  const [consent, setConsent] = useState(false);

  const interests = [
    "Software Development",
    "Data Science",
    "UI/UX Design",
    "Product Management",
    "Marketing",
    "Other",
  ];
  const [cvFile, setCvFile] = useState(null); // State to store the CV file


  const handleSubmit = async () => {

    if (!fullName || !email || !currentLocation || !primaryInterest || !consent) {
      toast.error('Please fill all required details')
      return
    }

    try {
      const formData = new FormData();
      formData.append('name', fullName);
      formData.append('email', email);
      formData.append('location', currentLocation);
      formData.append('interest', primaryInterest);
      if (cvFile) {
        formData.append('cv', cvFile); // Append the CV file
      }

      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/jobs/posttalentcommunity`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data' // Important for file uploads
        }
      });

      console.log('Application submitted:', response);

      if (response.data.success) {
        setFormSubmitted(true);
        // setIsApplySubmitModalOpen(true);
      }

    } catch (error) {
      console.error('Error submitting application:', error);
    }
  };

  return (
    <div className='bigscreen p-4'>

      <div className='relative flex flex-col justify-end items-center gap-10 min-h-[450px]'>

        <div className='mx-auto mt-0 w-fit bg-white text-center shadow p-6 relative !z-50 rounded-[20px]'>
          <div className='text-3xl font-bold'>
            Join Our <span className='text-[var(--primary)]'>Talent Community</span>
          </div>
          <div className='text- medium text-xs max-w-[400px] mt-6'>
            Didn’t find the right role? Let us know about you, and we’ll reach out when opportunities align with your expertise.

          </div>
          <div className='text-medium text-xs max-w-[400px] mt-1'>
            Being part of our talent community means you’ll be the first to know about exciting roles and career-building resources.
          </div>

          <button className='button mt-6 text-sm mx-auto'>Join the Talent Network</button>
        </div>

        <div className='mb-0 font-semibold text-center mx-auto'>
          <div className='text-sm italic'>Join over 1,000 professionals already part of the Hunt High Talent Network.</div>
        </div>

        <div className='absolute inset-0'>
          <img src={img} className='w-full max-h-full object-contain custom-mask opacity-90' />
        </div>

      </div>

      {formsubmitted ?
        <div className='mt-20 w-full max-w-[900px] bg-white rounded-[32px] shadow py-14 px-8 flex flex-col gap-6 mx-auto'>
          <div>
            <h3 className="text-xl font-bold text-gray-900">Thank you for joining the Hunt High Talent Network!</h3>
            <p className="text-sm text-gray-500 border-b pb-3 mt-6">Your details have been successfully submitted.
              <br /> We’ll notify you about relevant opportunities soon</p>
          </div>
        </div>

        :
        <div className='mt-20 w-full max-w-[900px] bg-white rounded-[32px] shadow py-6 px-8 flex flex-col gap-6 mx-auto'>

          <div>
            <h3 className="text-xl font-bold text-gray-900">Join The Hunt High Talent Network</h3>
            <p className="text-sm text-gray-500 border-b pb-3">Complete the following details and then we'll notify you about relevant opportunities soon</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700">
              Full Name
            </label>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              className="input w-full mt-2"
              placeholder="Enter your full name"
            />
          </div>

          {/* Email Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input w-full mt-2"
              placeholder="Enter your email"
            />
          </div>

          {/* Current Location Input */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Current Location
            </label>
            <input
              type="text"
              value={currentLocation}
              onChange={(e) => setCurrentLocation(e.target.value)}
              className="input w-full mt-2"
              placeholder="Enter your current location"
            />
          </div>

          {/* Dropdown for Primary Area of Interest */}
          <div>
            <label className="block text-sm font-medium text-gray-700">
              What is your primary area of expertise?
            </label>
            <select
              value={primaryInterest}
              onChange={(e) => setPrimaryInterest(e.target.value)}
              className="input w-full mt-2"
            >
              <option value="" disabled>
                Select an option
              </option>
              {interests.map((interest, index) => (
                <option key={index} value={interest}>
                  {interest}
                </option>
              ))}
            </select>
          </div>

          <label htmlFor="cvUpload" className="group relative flex items-center justify-center rounded-md border border-dashed border-gray-300 py-3 px-4 text-center cursor-pointer hover:border-blue-500 transition-colors duration-300">
            <div className="space-y-1 text-center">
              <svg
                className="mx-auto h-12 w-12 text-gray-400 group-hover:text-blue-500 transition-colors duration-300"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 48 48"
                aria-hidden="true"
              >
                <path
                  d="M28 8H12a4 4 0 0-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4V12a4 4 0 014-4h16m-8 0L24 3l4 5m-4 15v7m-8-7h16"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <div className="flex text-sm text-gray-600">
                {cvFile ?
                  <>
                    <span className="font-medium text-orange-500 group-hover:text-orange-600 transition-colors duration-300">
                      {cvFile.name}
                    </span>
                    <p className="pl-1">File Uploaded</p>
                  </>
                  : <>
                    <span className="font-medium text-blue-500 group-hover:text-blue-600 transition-colors duration-300">
                      Upload your CV
                    </span>
                    <p className="pl-1">or drag and drop</p>
                  </>
                }
              </div>
              <p className="text-xs text-gray-500">PDF, DOC, DOCX</p>
            </div>
            <input
              type="file"
              id="cvUpload"
              accept=".pdf,.doc,.docx"
              className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              onChange={(e) => {
                if (e.target.files && e.target.files[0]) {
                  console.log("CV uploaded:", e.target.files[0]);
                  // Store the file in state or perform other actions
                  // Example:
                  setCvFile(e.target.files[0]);
                  const file = e.target.files[0];
                  // You can now use the 'file' variable
                  // for further processing, such as uploading.
                }
              }}
            />
          </label>

          <div className="flex items-start">
            <input
              type="checkbox"
              id="consent"
              checked={consent}
              onChange={(e) => setConsent(e.target.checked)}
              className="w-4 h-4 mt-1 border-gray-300 rounded focus:ring-primary"
            />
            <label htmlFor="consent" className="ml-2 text-sm text-gray-700">
              I consent to my data being stored for future opportunities in accordance with the
              <a href='' className="text-primary underline"> privacy policy</a>.
            </label>
          </div>

          <button onClick={handleSubmit} className="button w-40 mx-auto">
            Submit
          </button>
        </div>
      }

      <Toaster richColors position='bottom-center' />
    </div>
  )
}

export default TalentCommunity